export default __webpack_public_path__ + "static/media/payment-popup-mobile.5ff4fdae.png";